import { combineReducers } from 'redux';
import { adminState } from './admin';
import { blogState } from './blog';
import { dashboardState } from './dashboard';
import { profileState } from './profile';
import { searchState } from './search';
import { uiState } from './ui';
import { userState } from './user';

export { emptyStoreData } from './initialState';

const reducer = combineReducers({
    admin: adminState,
    blog: blogState,
    dashboard: dashboardState,
    profile: profileState,
    search: searchState,
    ui: uiState,
    user: userState,
});

export default reducer;
